<button type="button" #declineApplicationDrawerButton command="show-modal" [attr.commandfor]="dialogId"
    (click)="resetFormOnOpen()"
    class="inline-flex items-center gap-x-1.5 rounded-full bg-red-100 px-2.5 py-1.5 text-sm font-medium text-red-700 shadow-sm hover:bg-red-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-400 dark:bg-red-500/15 dark:text-red-300 dark:hover:bg-red-500/25">
    @if (isUnHireFlow) {
    Un-Hire
    } @else {
    Decline
    }
</button>

<el-dialog>
    <dialog #declineApplicationDrawerDialog [id]="dialogId"
        [attr.aria-labelledby]="dialogId + '-title'"
        (keydown)="onDialogKeydown($event)"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">
        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>
        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">

            <el-dialog-panel
                class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl ">

                    <div class="h-full flex flex-col overflow-hidden divide-y divide-zinc-200 dark:divide-zinc-800">

                        <!-- header -->
                        <div class="px-2 py-4 drawer-header-primary">
                            <div class="flex space-x-3 h-full items-center">
                                <div class="min-w-0 flex-1 px-2 text-left">
                                    @if (applicationStatus === ApplicationStatusEnum.Applied) {
                                    <p [id]="dialogId + '-title'" class="text-md font-semibold text-primary">
                                        <!-- Decline Application  -->
                                        Decline {{ selectedApplication.creator?.firstName }}
                                        <!-- Decline {{ selectedApplication.id }} -->
                                    </p>
                                    <p class="text-sm text-secondary">
                                        Select a reason for declining this application.
                                    </p>
                                    }
                                    @if (isUnHireFlow) {
                                    <p [id]="dialogId + '-title'" class="text-md font-semibold text-primary">
                                        Un-Hire {{ selectedApplication.creator?.firstName }}
                                    </p>
                                    <p class="text-sm text-secondary">
                                        Select a reason for un-hiring this creator.
                                    </p>
                                    }
                                </div>

                                <div class="h-full flex flex-col justify-between items-end">

                                    <button type="button" (click)="closeDrawer()"
                                        class="fab-button-secondary text-secondary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                            <path d="M18 6 6 18" />
                                            <path d="m6 6 12 12" />
                                        </svg>
                                    </button>

                                </div>
                            </div>
                        </div>
                        <!-- header - END -->

                        <!-- main content -->
                        <div
                            class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-hidden drawer-body-primary divide-y divide-zinc-200 dark:divide-zinc-800 p-2">

                            <ul class="h-full overflow-y-auto scrollbar-transparent space-y-2">
                                @for (reason of isUnHireFlow ? unHireReasons : declineReasons; track reason.id) {
                                <li class="flex justify-between gap-x-6 py-5 card-container-pale">
                                    <div class="flex flex-row gap-x-2 items-center">
                                        <div
                                            class="size-10 flex flex-col items-center justify-center fab-button-secondary"
                                            aria-hidden="true">
                                            <!-- Icons match Shout App 2026 DeclineReasonSheet (lucide) -->
                                            @switch (reason.icon?.name) {
                                            @case ('person_remove') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <circle cx="9" cy="7" r="4" />
                                                <line x1="17" x2="22" y1="8" y2="13" />
                                                <line x1="22" x2="17" y1="8" y2="13" />
                                            </svg>
                                            }
                                            @case ('document_incomplete') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
                                                <path
                                                    d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                                                <path d="m15 11-6 6" />
                                                <path d="m9 11 6 6" />
                                            </svg>
                                            }
                                            @case ('padlock') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                                                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                            </svg>
                                            }
                                            @case ('trending_down') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M16 17h6v-6" />
                                                <path d="m22 17-8.5-8.5-5 5L2 7" />
                                            </svg>
                                            }
                                            @case ('theatre_masks') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M10 11h.01" />
                                                <path d="M14 6h.01" />
                                                <path d="M18 6h.01" />
                                                <path d="M6.5 13.1h.01" />
                                                <path d="M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3" />
                                                <path d="M17.4 9.9c-.8.8-2 .8-2.8 0" />
                                                <path
                                                    d="M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7" />
                                                <path d="M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4" />
                                            </svg>
                                            }
                                            @case ('warning') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path
                                                    d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                                <path d="M12 9v4" />
                                                <path d="M12 17h.01" />
                                            </svg>
                                            }
                                            @case ('cancel_circle') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <circle cx="12" cy="12" r="10" />
                                                <path d="m15 9-6 6" />
                                                <path d="m9 9 6 6" />
                                            </svg>
                                            }
                                            @case ('question_circle') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <circle cx="12" cy="12" r="10" />
                                                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                                                <path d="M12 17h.01" />
                                            </svg>
                                            }
                                            @case ('close') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M18 6 6 18" />
                                                <path d="m6 6 12 12" />
                                            </svg>
                                            }
                                            @case ('people') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                <circle cx="9" cy="7" r="4" />
                                            </svg>
                                            }
                                            @default {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <circle cx="12" cy="12" r="10" />
                                                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                                                <path d="M12 17h.01" />
                                            </svg>
                                            }
                                            }
                                        </div>

                                        <div class="min-w-0 flex flex-col items-center justify-start">
                                            <p class="text-sm font-semibold text-primary">
                                                {{ reason.name }}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="flex flex-col items-center justify-center">
                                        @if (selectedReason()?.id !== reason.id) {
                                        <a (click)="selectReason(reason)"
                                            class="hover:cursor-pointer rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50">Select</a>
                                        } @else {
                                        <button (click)="selectedReason.set(null)" type="button"
                                            class="fab-button-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                                                <path d="m9 11 3 3L22 4" />
                                            </svg>
                                        </button>
                                        }
                                    </div>
                                </li>
                                }

                                @if (selectedReason()?.id === 8 || otherReason()) {
                                <div class="mt-2 w-full text-left">
                                    <label for="comment" class="block text-sm/6 font-medium text-primary">Provide a
                                        reason</label>
                                    <div class="mt-1 px-2">
                                        <textarea id="comment" rows="3" [formField]="otherReasonsForm.otherReason"
                                            placeholder="A sentence describing the reason for declining the application."
                                            class="input-textarea text-primary"></textarea>
                                    </div>
                                </div>
                                }
                            </ul>

                        </div>
                        <!-- main content - END -->

                        <!-- Footer -->
                        @if (selectedReason()) {
                        <div class="px-4 py-4 drawer-header-primary flex flex-row items-center justify-end gap-x-4">
                            <button (click)="submit()" type="button" [disabled]="isSubmitDisabled()"
                                class="inline-flex items-center justify-center primary-button-danger disabled:opacity-50 disabled:cursor-not-allowed">
                                {{ isUnHireFlow ? 'Un-Hire' : 'Decline Application' }}
                            </button>
                        </div>
                        }
                        <!-- Footer - END -->
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>
